import { a as r } from "../internals/array-buffer-view-core.js";
import { f as t } from "../internals/fails.js";
import { g as n } from "../internals/global.js";
import { f as o } from "../internals/function-uncurry-this.js";
var i = r.exportTypedArrayMethod,
  a = n.Uint8Array,
  s = a && a.prototype || {},
  e = [].toString,
  f = o([].join);
t(function () {
  e.call({});
}) && (e = function e() {
  return f(this);
});
var l = s.toString != e;
i("toString", e, l);